/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSuggestRealtorFormModel,
  ISuggestRealtorFormRequest,
  IMappers,
  ISuggestRealtorFormResponse,
  ISuggestRealtorFormResponseError,
  TSuggestRealtorFormResponse,
} from './types';

const defaultConfig: TSuggestRealtorFormModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'geo-suggest',
  pathApi: '/v1/suggest-realtor-form/',
  hostType: 'api',
} as TSuggestRealtorFormModel;

function createSuggestRealtorFormModel(parameters: ISuggestRealtorFormRequest): TSuggestRealtorFormModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISuggestRealtorFormOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISuggestRealtorFormRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSuggestRealtorForm<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISuggestRealtorFormOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSuggestRealtorFormResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSuggestRealtorFormModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISuggestRealtorFormResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISuggestRealtorFormResponseError);
    }
  }

  return { response, statusCode } as TSuggestRealtorFormResponse;
}

export { defaultConfig, createSuggestRealtorFormModel, fetchSuggestRealtorForm };
